<mat-tab-group #tabGroup>
  <mat-tab #tonnageTab>
    <ng-template mat-tab-label>
      <mat-icon>directions_boat</mat-icon>
      <span>{{ 'statements.tonnage' | translate }}</span>
    </ng-template>
    <app-tonnage-grid #tonnageGrid></app-tonnage-grid>
  </mat-tab>
  <mat-tab #tollTab>
    <ng-template mat-tab-label>
      <mat-icon>directions_railway</mat-icon>
      <span>{{ 'statements.toll' | translate }}</span>
    </ng-template>
    <app-toll-grid #tollGrid></app-toll-grid>
  </mat-tab>
  <mat-tab #st4wTab *ngIf="uiService.isSupervision()">
    <ng-template mat-tab-label>
      <mat-icon>language</mat-icon>
      <span>{{ 'statements.st4w' | translate }}</span>
    </ng-template>
    <app-st4w-grid></app-st4w-grid>
  </mat-tab>
</mat-tab-group>